<div class="gamestatistics" [@animate]="enabled()" #elem>
    <div class="game-statistics-label" (mousedown)="mousedown($event)">
        <!--<div class="game-stats-close-icon" (click)="close()"><i class="fal fa-times"></i></div>-->
        <div class="game-stats-drag-icon"><i class="fal fa-arrows"></i></div>
        <div>Live game stats</div>
    </div>
    <div class="game-stats-content-wrap">
        <div class="game-stats-column">
            <div>Total bets</div>
            <div class="value" data-id="game-statistics-total">{{ data().wins + data().losses | number }}</div>
        </div>
        <div class="game-stats-column">
            <div>Wagered</div>
            <div class="value" data-id="game-statistics-wagered">{{ data().wagered | crypto: player.getCurrency() : false : true }}</div>
        </div>
        <!--<div class="game-stats-column">
            <div>Profit</div>
            <div class="value" [class.wins]="data().profit > 0" [class.losses]="data().profit < 0"
                 data-id="game-statistics-profit">
                {{ data().profit | number: '0.2' }}
            </div>
        </div>-->
        <div class="game-stats-column">
            <div>Wins</div>
            <div class="value wins" data-id="game-statistics-wins">{{ data().wins | number }}</div>
        </div>
        <div class="game-stats-column lastsc">
            <div>Losses</div>
            <div class="value losses" data-id="game-statistics-losses">{{ data().losses | number }}</div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/games/shared/game-statistics/game-statistics.template.html